import { Component, inject, effect, ViewContainerRef, viewChild, HostListener, input, signal } from '@angular/core';
import { NgStyle } from '@angular/common';
import { ModalService } from './modal-service';

@Component({
  selector: 'app-modal',
  imports: [NgStyle],
  templateUrl: './modal.html',
  styleUrl: 'modal.scss'
})
export class ModalComponent {
  readonly modalService = inject(ModalService);
  private readonly outlet = viewChild('outlet', { read: ViewContainerRef });
  modalContentExtraStyle = signal<Record<string, string>>({});
  isClosing = signal(false);

  constructor() {
    effect(() => {
      const config = this.modalService.config();
      const container = this.outlet();
      if (!container) return;
      container.clear();
      if (config) {
        const ref = container.createComponent(config.component);
        if (config.inputs) {
          for (const [key, value] of Object.entries(config.inputs)) {
            ref.setInput(key, value);
          }
        }
        const leftOffset = config.admin ? 'calc(50% - 620px + 125px)' : 'calc(50% - 620px)';
        this.modalContentExtraStyle.set({
          'top': `${config.top ?? 100}px`,
          'left': leftOffset
        });
      }
    });
    effect(()=> {
      if (this.modalService.shouldClose() === true) {
        this.closeWithAnimation(true);
      }
    });
  }

  onBackdropClick(closeOnBackdrop?: boolean): void {
    if (closeOnBackdrop !== false) {
      this.closeWithAnimation(false);
    }
  }

  closeWithAnimation(result: boolean): void {
    this.isClosing.set(true);
    setTimeout(() => {
      this.modalService.discardModal(result);
      this.isClosing.set(false);
    }, 400);
  }

  @HostListener('window:keydown.escape', ['$any($event)'])
  onEscKeyPress(event: KeyboardEvent): void {
    event.preventDefault();
    this.closeWithAnimation(false);
  }
}
